(() => {
	function JobTypesController(
		$scope,
		$rootScope,
		$http,
		messageService,
		$timeout,
		accountService
	) {
		const defaultWorkflow = {
			name: 'Default'
		};

		$scope.$on('$viewContentLoaded', () => {
			$scope.isSaveJobSpinnningWheelActive = false;
			$scope.isJobTypeHaveWorkflow = false;
			$scope.isDeleteJobSpinnningWheelActive = false;
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: ''
			};
			$scope.pagindis = true;
			$scope.jobTypes = [];
			$scope.totalItems = 0;
			$scope.searchText = '';
			$scope.pageRequest.search = '';
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			getCompanyId();
			$http.get('/protected/rest/job/types/colours').then(result => {
				if (result) {
					$scope.colours = result.data;
				}
			});
			$http.get('/protected/rest/job/source').then(result => {
				if (result) {
					$scope.workflows = result.data;
					$scope.workflows.workflowNames.push(defaultWorkflow);
				}
			});
		});

		function closeColorSelect() {
			$scope.active = !$scope.active;
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			console.log('get jobs data');

			let changed = false;
			if (
				typeof predicate !== 'undefined' &&
				predicate != null &&
				typeof reverse !== 'undefined' &&
				reverse != null
			) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http
					.get(
						`/protected/rest/job/types?perPage=${
							$scope.pageRequest.perPage
						}&page=${$scope.pageRequest.page}&predicate=${
							$scope.pageRequest.pageOrder.predicate
						}&reverse=${$scope.pageRequest.pageOrder.reverse}`
					)
					.then(result => {
						if (result.data && result.data.pageRequest) {
							$scope.pageRequest = result.data.pageRequest;
							$scope.pageRequest.search = $scope.searchText;
						}
						$scope.pageNumbers = [];
						$scope.totalItems = result.data.total;
						let pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
						pagesCount = Math.ceil(pagesCount);
						for (let i = 1; i <= pagesCount; i++) {
							$scope.pageNumbers[i - 1] = i;
						}
						$scope.jobTypes = result.data.results;
						// $scope.defaultJobType = $scope.jobTypes.find((type) => type.default);
						$scope.defaultJobType = {};
						console.log(result);
					});
			}
		}
		function getCompanyId() {
			accountService.companyIdObservable.subscribe(data => {
				$scope.companyId = data;
			});
		}
		$scope.editTypeModal = function(jobType) {
			$scope.jobTypeEdit = angular.copy(jobType) || {};
			if ($scope.active) {
				closeColorSelect();
			}
			if (
				$scope.jobTypeEdit.workflow !== undefined &&
				$scope.jobTypeEdit.workflow.id === null
			) {
				$scope.isJobTypeHaveWorkflow = true;
				$scope.jobTypeEdit.workflow = defaultWorkflow;
			}

			$('#jobTypeEditModal').modal('show');
		};
		$scope.deleteTypeModal = function(jobType) {
			$scope.jobTypeDelete = angular.copy(jobType);
			$('#jobTypeDeleteModal').modal('show');
		};
		$scope.deleteType = function() {
			$scope.isDeleteJobSpinnningWheelActive = true;
			$http
				.get(`/protected/rest/job/types/delete?id=${$scope.jobTypeDelete.id}`)
				.then(
					result => {
						if (result.errorMessage) {
							toastr.error('Try again later.', 'Server error.');
						} else {
							messageService.showToaster(
								's_0',
								'jobTypes',
								$scope.jobTypeDelete.name
							);
							$('#jobTypeDeleteModal').modal('hide');
							getResultsPage(
								$scope.pageRequest.page,
								$scope.pageRequest.perPage
							);
							if (
								parseInt(
									localStorage.getItem(`dashboardJobType${$scope.companyId}`)
								) === $scope.jobTypeDelete.id
							) {
								localStorage.setItem(
									`dashboardJobType${$scope.companyId}`,
									'-1'
								);
							}
						}
						$scope.isDeleteJobSpinnningWheelActive = false;
					},
					() => {
						messageService.showToaster('e_3', 'jobTypes');
						$scope.isDeleteJobSpinnningWheelActive = false;
					}
				);
		};

		$scope.setColor = function(colour) {
			closeColorSelect();
			$scope.jobTypeEdit.colour = colour;
		};

		$scope.editType = function() {
			if ($scope.jobTypeEdit.workflow === undefined) {
				delete $scope.jobTypeEdit.workflow;
			}

			$scope.isSaveJobSpinnningWheelActive = true;
			if (!$scope.jobTypeEdit.name) {
				$scope.isSaveJobSpinnningWheelActive = false;
				return messageService.showToaster('e_2', 'jobTypes');
			}

			if (!$scope.jobTypeEdit.colour) {
				$scope.isSaveJobSpinnningWheelActive = false;
				return messageService.showToaster('e_1', 'jobTypes');
			}

			$http
				.post('/protected/rest/job/types/edit', $scope.jobTypeEdit)
				.then(() => $scope.successTypeEdit($scope.jobTypeEdit))
				.catch(messageService.showDefaultErrorMessage);
		};

		$scope.successTypeEdit = jobTypeEdit => {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);

			if (jobTypeEdit.id) {
				messageService.showToaster('s_1', 'jobTypes', $scope.jobTypeEdit.name);
			} else {
				messageService.showToaster('s_2', 'jobTypes', $scope.jobTypeEdit.name);
			}

			$('#jobTypeEditModal').modal('hide');

			$scope.isSaveJobSpinnningWheelActive = false;
		};

		$scope.updateSelection = function(position, jobTypes, id) {
			jobTypes.map((jobType, index) => {
				if (position !== index) {
					jobType.default = false;
				} else {
					jobType.default = true;
					if ($scope.defaultJobType.id !== jobType.id) {
						$http.post(
							`/protected/rest/job/types/default/${id}`,
							$scope.jobTypes
						);
					}
					$scope.defaultJobType.id = jobType.id;
				}
			});
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Job Types' }
		];
	}

	angular.module('main').controller('JobTypesController', JobTypesController);

	JobTypesController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'messageService',
		'$timeout',
		'accountService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/jobTypesController.js